import React from 'react'
import { Box, ListItem, ListItemIcon, ListItemText, List, Paper, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { motion } from 'framer-motion';

function ServiceItem({ texts, title, img}) {
  return (
    <motion.div
      initial={{
        x: "-100%",
        opacity: 0,
      }}
      whileInView={{
        x: 0,
        opacity: 1,
      }}
      transition={{
        delay: 0.5,
        type: "spring",
        ease: "linear",
      }}
      style={{
        display: "flex",
        height: "100%"
      }}
    >
        <Paper sx={{ padding: "20px" }} elevation={3}>
          <img src={img} alt="server" width={50} height={50} />
          <Typography variant='h4' sx={{ fontWeight: "500" }} fontSize={{ xs:"22px" }}>{title}</Typography>
          <List>
            {
              texts.map((text, index) => (
                <ListItem disablePadding key={index}>
                  <ListItemIcon>
                    <CheckCircle color='success' />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItem>
              ))
            }
          </List>
        </Paper>
    </motion.div>
  )
}

export default ServiceItem